import React from 'react';
import './Loading.css';

interface LoadingProps {
  text?: string;
  size?: 'small' | 'medium' | 'large';
}

export const Loading: React.FC<LoadingProps> = ({
  text = 'Loading...',
  size = 'medium'
}) => {
  return (
    <div className={`loading loading--${size}`}>
      <div className="loading__spinner" />
      {text && <span className="loading__text">{text}</span>}
    </div>
  );
};

interface LoadingOverlayProps {
  text?: string;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  text = 'Processing...'
}) => {
  return (
    <div className="loading-overlay">
      <div className="loading__spinner" />
      {text && <span className="loading__text">{text}</span>}
    </div>
  );
};

export default Loading;
